module.exports = __webpack_public_path__ + "img/70f3.a6658a86.jpg";